import { useState, useRef } from "react";

import * as S from './styles';

import { ReactComponent as MoreOneIcon } from "assets/more.svg";
import useClickOutside from "hooks/useClickOutside";

export type DataTableMenuItem<T> = {
  id: string;
  label: string;
  onClick: (menuItemId: string, data: T) => void;
  hide?: (data: T) => boolean;
}

type DataTableMenuProps<T> = {
  title?: string;
  data: T;
  options: DataTableMenuItem<T>[];
}

export function DataTableMenu<T>({
  title = 'Ver mais ações',
  options: menuOptions,
  data,
}: DataTableMenuProps<T>) {
  const [showOptions, setShowOptions] = useState<boolean>(false);

  const tooltipRef = useRef<HTMLDivElement>(null);

  useClickOutside({
    ref: tooltipRef,
    onClickOutside: () => setShowOptions(false),
  });

  const options = menuOptions.filter(el => el.hide !== undefined ? el.hide(data) : true);

  return (
    <S.Wrapper id='action_menu' className="action__wrapper">
      {options.length === 1 ? (
        <div className="action__badge unique" onClick={() => {
          options[0].onClick(options[0].id, data);
        }}>
          <span>{options[0].label}</span>
        </div> 
      ) : (
        <div className="action__badge" onClick={() => setShowOptions(!showOptions)}>
          <span>{title}</span>
          <MoreOneIcon />
        </div> 
      )}

      {showOptions && (
        <S.Menu className="action__menu" ref={tooltipRef}>
          {options.map((option) => (
            <S.MenuItem key={option.id} onClick={() => {
              option.onClick(option.id, data);
              setShowOptions(false);
            }}>
              <span>{option.label}</span>
            </S.MenuItem>
          ))}
        </S.Menu>
      )}
    </S.Wrapper>
  )
};